import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import ConfirmDialog from '../Dialog/ConfirmationDialog';
import EditableSectionHeader from '../EditableSectionHeader';

interface EditableSectionProps {
  title: string;
  onSaveChanges: (utils: { toggleEditMode: () => void; }) => void;
  children: (params: { isEditMode: boolean }) => React.ReactNode;
  dataTestId?: string;
}

const EditableSection = ({ title, onSaveChanges, children, dataTestId }: EditableSectionProps) => {
  const { t } = useTranslation();
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const toggleConfirmDialog = () => setIsConfirmDialogOpen(prev => !prev);
  const toggleEditMode = () => setIsEditMode(prev => !prev);

  const confirmDiscardAndClose = () => {
    toggleEditMode();
    toggleConfirmDialog();
  };

  const onClickSave = () => {
    onSaveChanges({ toggleEditMode });
  };

  return (
    <Box data-testid={dataTestId}>
      <EditableSectionHeader
        title={title}
        isEditMode={isEditMode}
        onEdit={toggleEditMode}
        toggleConfirmDialog={toggleConfirmDialog}
        onSave={onClickSave}
      />
      {children({ isEditMode })}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        title={t('Quit editing without saving')}
        message={t('Changes you made may not be saved. Are you sure you want to cancel your changes?')}
        onConfirm={confirmDiscardAndClose}
        onCloseModal={toggleConfirmDialog}
        confirmButtonText={t('Discard')}
        confirmButtonColor='error'
      />
    </Box>
  );
};

export default EditableSection;
